import React from 'react';
import ViewTemplate from '../components/Settings/Templates/ViewTemplate';

export default function ViewTemplateRoute(props) {
  return <ViewTemplate {...props} />;
}
